import React, { Fragment } from 'react';
import { DateTime } from 'luxon';
import PropTypes from 'prop-types';

import { OPTION_TYPES } from '../../../models/ShippingOption';
import styles from './ShippingSummary.css';

const ITimeSlots = PropTypes.arrayOf(PropTypes.shape({
  id: PropTypes.string,
  date: PropTypes.instanceOf(DateTime),
  startHour: PropTypes.number,
  endHour: PropTypes.number,
}));

const ISimpleOption = PropTypes.shape({
  date: PropTypes.instanceOf(DateTime),
  endHour: PropTypes.number,
  id: PropTypes.string,
  optionType: PropTypes.oneOf([OPTION_TYPES.SIMPLE]),
  price: PropTypes.number,
  startHour: PropTypes.number,
});

const ISpecialOption = PropTypes.shape({
  id: PropTypes.string,
  optionType: PropTypes.oneOf([OPTION_TYPES.SPECIAL]),
  timeSlots: ITimeSlots,
});

const IAgencyOption = PropTypes.shape({
  id: PropTypes.string,
  price: PropTypes.number,
  name: PropTypes.string,
  optionType: PropTypes.oneOf([OPTION_TYPES.AGENCY]),
  agencies: PropTypes.arrayOf(PropTypes.shape({
    extraCost: PropTypes.number,
    id: PropTypes.id,
    name: PropTypes.string,
  })),
  timeSlots: ITimeSlots,
});

const IPropTypes = {
  className: PropTypes.string,
  agencyId: PropTypes.number,
  option: PropTypes.oneOfType([
    IAgencyOption,
    ISpecialOption,
    ISimpleOption,
  ]),
};

const defaultProps = {
  agencyId: null,
  className: '',
  option: null,
};

const ShippingSummary = props => (
  <div className={[styles.container, props.className].join(' ')}>
    {
      props.option && (props.option.optionType === OPTION_TYPES.AGENCY
        ? (
          <Fragment>
            <div className={styles.textRow}>
              <p className={styles.text}>
                Costo por despacho
              </p>
              <p className={styles.text}>
                ${props.option.price}
              </p>
            </div>
            <div className={styles.textRow}>
              <p className={styles.text}>
                Piso de agencia
              </p>
              <p className={styles.text}>
                {
                  props.agencyId
                    ? `$${props.option.agencies.find(a => a.id === props.agencyId).extraCost}`
                    : '-'
                }
              </p>
            </div>
            <div className={styles.textRow}>
              <p className={styles.text}>
                Envío por agencia
              </p>
              <p className={styles.text}>
                + costo a definir
              </p>
            </div>
          </Fragment>
        )
        : (
          <Fragment>
            <div className={styles.textRow}>
              <p className={styles.text}>
                Costo de envío
              </p>
              <p className={styles.text}>
                ${props.option.price}
              </p>
            </div>
          </Fragment>
        ))
    }
  </div>
);

ShippingSummary.propTypes = IPropTypes;
ShippingSummary.defaultProps = defaultProps;

export { ShippingSummary };



// WEBPACK FOOTER //
// ./src/pages/shipping-options/shipping-summary/ShippingSummary.jsx